import { relativeTime, type RefreshStep } from '@region13/shared-types'
import { useInleagueHealth } from '../lib/inleagueStatus'

/** "InLeague data as of 3 hours ago", under the heading of the pages whose data
 *  comes from InLeague (spec 2026-10-08, amended): each page names the refresh
 *  step its data comes from. Coach Home `teams`, coach Jerseys `players`,
 *  referee My assignments and Open slots `directory`, the Stats review queue
 *  `teams`. It tells a reader why a roster or a referee can be out of date.
 *
 *  Reads the same poll as InleagueStatusBanner, so a page with both makes one
 *  fetch. Renders nothing when there is no time to show: off our zone, no
 *  reading yet, or no refresh run has read that step. A failed poll keeps the
 *  last known time. The phrase is worked out on each poll result, so it moves
 *  every INLEAGUE_POLL_MS with no clock of its own.
 *  Muted and plain because it is information, not a warning, and no link
 *  because these readers cannot run a sync. `hostname` is a parameter only so
 *  tests can pass one. */
export function InleagueLastRead({
  step,
  hostname = window.location.hostname,
  className = '',
}: {
  step: RefreshStep
  hostname?: string
  className?: string
}) {
  const at = useInleagueHealth(hostname).lastRead[step]
  if (!at) return null
  return <p className={`text-sm text-ink-mut ${className}`.trim()}>{`InLeague data as of ${relativeTime(at)}`}</p>
}
